import { Vue, i18n } from 'Components/vue';
import Ratings from 'VueComponents/Ratings';
import "Functions/adyen-payment";

if (document.getElementById('ratingsBox')) {
    window.$_ratings = new Vue({
        i18n,
        render: h => h(Ratings)
    }).$mount("#ratingsBox");
}
